// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import config from '../../../../share/config';
import session from '../../../../share/session';
import util from '../../../../share/util/utils';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  WRITING: 'writing',
  EG_OFF: 'egOff',
  SWITCH_TO_FF: 'switchToFF',
  RETURN_TO_AWD: 'returnToAWD',
  SWITCH_TO_AWD: 'switchToAWD',
  P_RANGE_SELECT: 'pRangeSelect',
  SUCCESS_SWITCH_TO_AWD: 'successSwitchToAWD',
  SUCCESS_SWITCH_TO_FF: 'successSwitchToFF',
  FAILURE: 'failure',
  FAILED: 'failed'
};

export default {
  name: 'workSupport025',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      systemId: '',
      numWaitTime: 0,
      // ダイアログフラグ
      modal_requirement_025: false,
      executionMsg: ''
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.FAILURE:
          return 'danger';
        case PHASE.SUCCESS_SWITCH_TO_AWD:
        case PHASE.SUCCESS_SWITCH_TO_FF:
          return 'success';
        case PHASE.START:
        case PHASE.EG_OFF:
        case PHASE.SWITCH_TO_FF:
        case PHASE.RETURN_TO_AWD:
        case PHASE.SWITCH_TO_AWD:
        case PHASE.P_RANGE_SELECT:
        default:
          return 'secondary';
      }
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      this.executionMsg = '';
      this.modal_requirement_025 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_025 = false;
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result handler.validate で返ってきたバリデーション結果
    */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** エンジン状態確認 読み出し処理 */
    async getEngineStatus() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-start'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // 切り替え完了フラグ初期化を実行
                  await this.initSwitchCompleteFlg();
                  break;
                case 'ng':
                  // エンジン停止指示表示画面へ遷移
                  this.phase = PHASE.EG_OFF;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 切り替え完了フラグ初期化 */
    async initSwitchCompleteFlg() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write_with_session_transition'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：実行モード確認読み出し処理を実行
              await this.getExecuteMode();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 実行モード確認読み出し処理 */
    async getExecuteMode() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-execute_mode'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.result) {
                case 'awd':
                  // FF切り替え確認表示画面へ遷移
                  this.phase = PHASE.SWITCH_TO_FF;
                  break;
                case 'ff':
                  // AWD切り替え確認表示
                  this.phase = PHASE.SWITCH_TO_AWD;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** FF切り替え確認表示画面 OKボタン押下処理 */
    async showReturnAWDPage() {
      // AWD戻し確認表示画面へ遷移
      this.phase = PHASE.RETURN_TO_AWD;
      return;
    },

    /** シフト状態確認読み出し処理 */
    async getShiftStatus() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-check_shift_status'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // エンジン状態確認（２回目）画面へ遷移
                  await this.getEngineStatusSecond();
                  break;
                case 'ng':
                  // Pレンジ指示表示画面へ遷移
                  this.phase = PHASE.P_RANGE_SELECT;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** エンジン状態読み出し処理（２回目） */
    async getEngineStatusSecond() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-engine_status_check'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  this.executionMsg = `${this.i18nWsKey}.REQ_WS_25_TXT_6`;
                  // レスポンスが0x00の場合、駆動モード判定画面へ遷移
                  this.phase = PHASE.WRITING;
                  await this.getDriveModeChk();
                  break;
                case 'ng':
                  // エンジン停止指示表示（2回目）画面へ遷移
                  this.errorMsg = `${this.i18nWsKey}.REQ_WS_25_TXT_9`;
                  this.phase = PHASE.FAILURE;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 駆動モード判定処理 */
    async getDriveModeChk() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-driving_mode_judgment'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.result) {
                case 'awd':
                  // FF切り替え処理を実行
                  await this.writeDriveFF();
                  break;
                case 'ff':
                  // AWD切り替え処理を実行
                  await this.writeDriveAWD();
                  break;
                case 'err':
                  // 終了処理(エラー遷移あり)
                  await this.exitLogic(0);
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** FF切り替え処理書込み処理 */
    async writeDriveFF() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write-ff_switching'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：指定時間を計測
              this.numWaitTime = response.data.user_data.wait_time;
              await util.sleep(this.numWaitTime);
              this.numWaitTime = 0;
              // 指定時間経過後、切り替え完了フラグ確認を実行
              await this.getSwitchCompleteFlg();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** AWD切り替え処理 */
    async writeDriveAWD() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write-awd_switching'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：指定時間を計測
              this.numWaitTime = response.data.user_data.wait_time;
              await util.sleep(this.numWaitTime);
              this.numWaitTime = 0;
              // 指定時間経過後、切り替え完了フラグ確認を実行
              await this.getSwitchCompleteFlg();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 切り替え完了フラグ読み出し処理
     */
    async getSwitchCompleteFlg() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-check_switch_completion_flag'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // AWD/FF情報読出しを実行
                  await this.getDriveSystem();
                  break;
                case 'ng':
                  // 失敗表示画面へ遷移
                  this.errorMsg = `${this.i18nWsKey}.REQ_WS_25_TXT_10`;
                  this.phase = PHASE.FAILURE;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** AWD/FF情報読出し処理 */
    async getDriveSystem() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-awd_ff'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.result) {
                case 'awd':
                  // AWD切り替え成功表示画面へ遷移
                  this.phase = PHASE.SUCCESS_SWITCH_TO_AWD;
                  break;
                case 'ff':
                  // FF切り替え成功表示画面へ遷移
                  this.phase = PHASE.SUCCESS_SWITCH_TO_FF;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 終了処理 */
    async exitLogic(intError) {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (intError === 0) {
          // エラー遷移あり
          if (response) {
            // 正常コールバック
            switch (response.data.status) {
              case config.STATUS_WSP_COMPLETED:
                // 正常終了：機能終了
                this.closeWizard();
                break;
              case config.STATUS_WSP_FAILED:
              default:
                // 異常終了：汎用エラー
                this.showUnexpectedError();
                return;
            }
          }
        } else {
          // エラー遷移なし：機能終了
          this.closeWizard();
          return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 異常終了：汎用エラーを表示
      this.phase = PHASE.FAILED;
    },
  },

  async mounted() {
    this.init();
    // エンジン状態確認 読み出し処理
    this.getEngineStatus();
  },
};